module.exports = __webpack_public_path__ + "images/icons/logos/brand-white-22277887.svg";